import React from 'react';
import { Button } from '../Button';

type ChannelType = 'all' | 'whatsapp' | 'email';

interface ChannelFilterProps {
  activeChannel: ChannelType;
  onChannelChange: (channel: ChannelType) => void;
  whatsappCount?: number;
  emailCount?: number;
}

export const ChannelFilter: React.FC<ChannelFilterProps> = ({
  activeChannel,
  onChannelChange,
  whatsappCount = 0,
  emailCount = 0
}) => {
  return (
    <div className="flex gap-1 px-3 py-3 border-b border-border bg-background sticky top-0 z-0 w-full">
      <div className="flex gap-1 w-full max-w-[1280px] mx-auto">
        <Button
          variant={activeChannel === 'all' ? 'primary' : 'ghost'}
          size="sm"
          onClick={() => onChannelChange('all')}
          className="text-xs font-medium"
        >
          Todos ({whatsappCount + emailCount})
        </Button>
        <Button
          variant={activeChannel === 'whatsapp' ? 'primary' : 'ghost'}
          size="sm"
          onClick={() => onChannelChange('whatsapp')}
          className="text-xs font-medium"
        >
          WhatsApp ({whatsappCount})
        </Button>
        <Button
          variant={activeChannel === 'email' ? 'primary' : 'ghost'}
          size="sm"
          onClick={() => onChannelChange('email')}
          className="text-xs font-medium"
        >
          Email ({emailCount})
        </Button>
      </div>
    </div>
  );
};

export default ChannelFilter;
